import React from 'react'
import CartCoupon from './CartCoupon'
import CartMenu from './CartMenu'
import CartProduct from './CartProduct'
import { CLIENT_MONITOR_COUPON_TYPES } from '../../../../../redux/selector/cart/constants'

const CartItem = React.memo(({ item, index }) => {
	return (
		item?.type === 'MENU' ?
			<CartMenu item={item} index={index} /> :
			([...CLIENT_MONITOR_COUPON_TYPES, 'GIFT_COUPON'].includes(item?.type)) ?
				<CartCoupon coupon={item} /> :
				<CartProduct item={item} index={index} />
	)
})

CartItem.displayName = 'CartItem'
export default CartItem
